import requestUtils from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-svc-merchandise'

type Response = paths['/api/merchandise/brands/top']['get']['responses']['200']['content']['application/json']

function getMerchandiseTopBrands(): Promise<Array<App.MerchandiseBrand>> {
  return requestUtils.get<Response>('/api/merchandise/brands/top').then((response) => {
    return response.result.topBrands.map((serverBrand) => ({
      id: serverBrand.id,
      name: serverBrand.name,
      slug: serverBrand.slug,
      logo: serverBrand.logoId ? {
        id: serverBrand.logoId,
        title: serverBrand.name,
      } : undefined,
      image: serverBrand.displayImageId ? {
        id: serverBrand.displayImageId,
        title: serverBrand.name,
      } : undefined,
    }))
  })
}

export default getMerchandiseTopBrands
